/* eslint-disable no-console */
'use strict'

import {Lang} from 'yougile-lang'
import {logger, Util} from 'yougile-util'
import {Backend} from '@common/backend'
import {addGoogleSignIn} from '@common/google-sign-in'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {UserCardClient} from '@common/user-card-client'

// Types and Interfaces
type UUID = string & {__type: 'UUID'}

type DataObjectId = UUID & {__subtype: 'DataObjectId'}

interface CheckEmailResp extends GenResp {
  foundUserId?: DataObjectId
  invitedUserId?: DataObjectId
}

interface GenResp {
  result: 'ok' | 'error'
  error?: string
  reqId?: UUID
  clientType?: string
  v?: number // minorVersion
}

interface RegisterResp extends GenResp {
  userId?: DataObjectId
}

// Constants
const disabledUserId = 'not available' as DataObjectId
const msg = Lang.getMessages((window as any).PAGE_LANG || 'en')

export class SubmissionsController {
  private static isRegPopupOpen = false

  private static setRegError(el: Element, message: string): void {
    const err = el.querySelector<HTMLElement>('.s-reg-error')
    if (message) {
      err.textContent = message
      err.style.display = 'block'
    } else {
      err.style.display = 'none'
    }
  }

  private static setRegLongError(el: Element, message: string): void {
    const err = el.querySelector<HTMLElement>('.s-reg-result-error')
    if (message) {
      err.textContent = message
      err.style.display = 'block'
    } else {
      err.style.display = 'none'
    }
  }

  private static googleAuthButton(): void {
    const btn = document.querySelector('.sign-in-button')
    btn?.addEventListener('click', () => {
      void Tracking.send(TrackingEvent.landingSignInButtonClick)
    })
  }

  private static registerSubmit(): void {
    const regs = document.querySelectorAll('.s-reg')
    const regWrapper = document.querySelector('.s-reg-wrapper')
    for (const reg of Util.iter(regs)) {
      const input = reg.querySelector<HTMLInputElement>('.s-reg-email')
      const inputParent = input.parentElement
      const btn = reg.querySelector('.s-reg-btn')
      const cancel = regWrapper.querySelector('.s-reg-cancel')
      const errorBadge = reg.querySelector<HTMLInputElement>('.s-reg-error')
      const errorGenericMessage =
        'Неизвестная ошибка :( Попробуйте обновить страницу и повторить попытку.'

      if (cancel) {
        cancel.addEventListener('click', () => {
          document.body.classList.remove('s-reg-show')
          document.body.classList.remove('blur')
          this.isRegPopupOpen = false
          document.body.style.paddingRight = '0'
        })
      }

      const submit = async () => {
        btn.setAttribute('disabled', 'disabled')
        SubmissionsController.setRegError(reg, '')
        SubmissionsController.setRegLongError(reg, '')

        const email = Util.cleanEmail(input.value)
        if (email) {
          Tracking.send(TrackingEvent.regFormClick, {
            fromPopup: this.isRegPopupOpen
          })
        }
        if (!Util.isEmail(email)) {
          btn.removeAttribute('disabled')
          SubmissionsController.setRegError(reg, msg.emailIncorrect2)
          input.focus()
          inputParent.classList.add('error')
          return
        }

        const checkUrl = '/data/register/check-email'
        let res
        try {
          res = await Backend.postJSON<CheckEmailResp>(checkUrl, {email})
        } catch (error) {
          btn.removeAttribute('disabled')
          Tracking.send(TrackingEvent.regFormError)
          console.error('Backend Error:', error)
          if (reg && !reg.classList.contains('modal-body')) {
            reg.classList.add('error')
          }
          SubmissionsController.setRegLongError(reg, errorGenericMessage)
          return
        }

        if (res.result === 'ok' && !res.foundUserId) {
          const regUrl = '/data/reg-request'
          const pageLang = (window as any).PAGE_LANG
          let res2
          try {
            res2 = await Backend.postJSON<RegisterResp>(regUrl, {
              email,
              lang: pageLang
            })
          } catch (error) {
            btn.removeAttribute('disabled')
            Tracking.send(TrackingEvent.regFormError)
            console.error('Backend Error:', error)
            if (reg && !reg.classList.contains('modal-body')) {
              reg.classList.add('error')
            }
            SubmissionsController.setRegLongError(reg, errorGenericMessage)
            return
          }

          if (res2.result === 'ok') {
            if (res2.userId) {
              UserCardClient.getInstance().trackRegistration(res2.userId)
            }
            btn.removeAttribute('disabled')
            reg.classList.add('done')
            Tracking.send(TrackingEvent.regFormSuccess)
            SubmissionsController.setRegError(reg, '')
            SubmissionsController.setRegLongError(reg, '')
          } else {
            btn.removeAttribute('disabled')
            Tracking.send(TrackingEvent.regFormError)
            if (reg && !reg.classList.contains('modal-body')) {
              reg.classList.add('error')
            }
            SubmissionsController.setRegLongError(reg, errorGenericMessage)
          }
        } else {
          const err =
            res.foundUserId === disabledUserId
              ? msg.reg.cantRegisterEmail
              : msg.emailExists
          btn.removeAttribute('disabled')
          Tracking.send(TrackingEvent.regFormExists)
          SubmissionsController.setRegError(reg, err)
        }
      }

      btn.addEventListener('click', submit)

      input.addEventListener('keydown', (e: KeyboardEvent) => {
        SubmissionsController.setRegError(reg, '')
        SubmissionsController.setRegLongError(reg, '')
        inputParent.classList.remove('error')
        if (e.keyCode === 13) {
          submit()
        }
      })

      input.addEventListener('blur', () => {
        errorBadge.style.display = 'none'
        inputParent.classList.remove('error')
      })
    }
  }

  private static boxRequestSubmit(): void {
    const wnds = document.querySelectorAll('.s-box')
    for (const wnd of Array.from(wnds)) {
      const closeModal =
        wnd.querySelector('.modal-close.s-link') ||
        wnd.querySelector('form .s-link')
      const close = wnd.querySelector('form .s-link')
      const closeDone = wnd.querySelector('.s-done .s-link')
      const overlay = wnd.querySelector('.s-box-overlay')
      const errorPlaceholder = wnd.querySelector('.s-error')

      ;[closeModal, close, overlay, closeDone].forEach(el => {
        if (el) {
          el.addEventListener('click', () => {
            document.body.classList.remove('blur')
            document.body.classList.remove('s-box-show')
            document.body.classList.remove('s-box-show-no-download')
            document.body.classList.remove('s-box-show-platform')
            wnd.classList.remove('error')
            wnd.classList.remove('done')
            wnd.getElementsByTagName('form')[0].reset()
            document.body.style.paddingRight = '0'
            clearAllErrors()
          })
        }
      })

      const submit = wnd.querySelector<HTMLButtonElement>('.s-btn')
      const form = wnd.querySelector('form')
      const inputs = form.querySelectorAll('input')

      const clearAllErrors = (): void => {
        if (wnd.classList.contains('error')) {
          wnd.classList.remove('error')
        }

        for (const i of Array.from(inputs)) {
          i.classList.remove('error')
        }

        errorPlaceholder.innerHTML = ''
      }

      for (const input of Array.from(inputs)) {
        input.addEventListener('keyup', () => clearAllErrors())
      }

      submit.addEventListener('click', async () => {
        submit.setAttribute('disabled', 'disabled')

        clearAllErrors()
        const fields = form.querySelectorAll('[name]')
        const param: Record<string, string> = {
          page: location.href
        }

        ;[...Array.from(fields)].forEach(
          (el: HTMLInputElement) => (param[el.name] = el.value)
        )

        if (document.body.classList.contains('s-box-show-platform')) {
          param.platform = '1'
        }

        const res = await Backend.postJSON<GenResp>('/data/box-req', param, {
          rawErrors: true
        })

        submit.removeAttribute('disabled')

        if (res.result === 'ok') {
          wnd.classList.add('done')

          if (wnd.classList.contains('no-download')) {
            const requestCallTrackingEventOrigin = wnd.getAttribute(
              'data-request-call-tracking-event-origin'
            )
            if (requestCallTrackingEventOrigin) {
              if (requestCallTrackingEventOrigin !== 'prices-main-screen') {
                Tracking.send(TrackingEvent.landingRequestCall, {
                  from: requestCallTrackingEventOrigin
                })
              } else {
                const eventType =
                  param.platform === '1'
                    ? TrackingEvent.landingRequestCallAboutPlatform
                    : TrackingEvent.landingRequestCallAboutBox
                Tracking.send(eventType, {from: requestCallTrackingEventOrigin})
              }
            }
          }
        } else {
          wnd.classList.add('error')

          if (this.hasErrorFields(res) && res.errorFields.length > 0) {
            res.errorFields.forEach((f: string) => {
              form.querySelector(`[name=${f}]`).classList.add('error')
            })
            errorPlaceholder.innerHTML =
              'Проверьте правильность заполнения полей, выделенных красным.'
          } else {
            errorPlaceholder.innerHTML =
              'Неизвестная ошибка :( Попробуйте обновить страницу и повторить попытку.'
          }
        }
      })
    }
  }

  private static hasErrorFields(obj: any): obj is {errorFields: string[]} {
    return obj && typeof obj.errorFields !== 'undefined'
  }

  private static appAppDownloads(): void {
    const btns = document.querySelectorAll('.dl-button')
    const distUrl = 'https://dist.yougile.com/app'
    const now = Date.now()

    function showNotification(message: string): void {
      const overlay = document.createElement('div')
      overlay.style.position = 'fixed'
      overlay.style.top = '0'
      overlay.style.left = '0'
      overlay.style.width = '100%'
      overlay.style.height = '100%'
      overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'
      // overlay.style.backdropFilter = 'blur(5px)';
      overlay.style.zIndex = '1000'

      const notification = document.createElement('div')
      notification.textContent = message
      notification.style.position = 'absolute'
      notification.style.top = '50%'
      notification.style.left = '50%'
      notification.style.transform = 'translate(-50%, -50%)'
      notification.style.backgroundColor = '#fff'
      notification.style.color = '#000'
      notification.style.padding = '20px'
      notification.style.borderRadius = '8px'
      notification.style.boxShadow = '0px 2px 10px rgba(0, 0, 0, 0.3)'
      notification.style.fontFamily = 'Arial, sans-serif'
      notification.style.fontSize = '16px'
      notification.style.textAlign = 'center'

      overlay.appendChild(notification)
      document.body.appendChild(overlay)

      overlay.addEventListener('click', e => {
        if (e.target === overlay) {
          document.body.removeChild(overlay)
        }
      })

      setTimeout(() => {
        if (document.body.contains(overlay)) {
          document.body.removeChild(overlay)
        }
      }, 3000)
    }
    Backend.requestRawJSON({
      url: `${distUrl}/latest.json?t=${now}`,
      method: 'GET'
    })
      .then((data: {version: string}) => {
        if (data && 'version' in data) {
          const {version} = data
          const files: {[type: string]: string} = {
            win32: `YouGile-Setup-${version}-ia32.exe`,
            win64: `YouGile-Setup-${version}-x64.exe`,
            mac: `YouGile-${version}.dmg`,
            linux: `YouGile-${version}-x86_64.AppImage`
          }
          for (const btn of Util.iter(btns)) {
            const os = (btn as HTMLElement).dataset.os
            btn.addEventListener('click', () => {
              window.open(`${distUrl}/${files[os]}`)
            })
          }
        } else {
          for (const btn of Util.iter(btns)) {
            btn.addEventListener('click', () => {
              showNotification(
                'Failed to load the latest version. Please try again later.'
              )
            })
          }
        }
      })
      .catch(e => logger.warn('Failed to load latest.json', e))
  }

  private static openProductPageButton(): void {
    document
      .getElementById('open-product-page')
      ?.addEventListener('click', () => {
        Tracking.send(TrackingEvent.landingOpenProductPageButtonClick)
      })
  }

  public static start(): void {
    this.googleAuthButton()
    this.registerSubmit()
    this.boxRequestSubmit()
    this.appAppDownloads()
    this.openProductPageButton()
    UserCardClient.init()
    addGoogleSignIn(undefined)
  }
}
